import { CapoPlugin } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];